import React from 'react'

type SectionVariant = 'neutral' | 'entity' | 'scope' | 'documents'

const variantClasses: Record<SectionVariant, string> = {
  neutral: 'bg-gray-50/80 border-gray-200',
  entity: 'bg-blue-50/50 border-blue-100',
  scope: 'bg-white border-gray-200',
  documents: 'bg-slate-50/80 border-slate-200',
}

export interface RequestSectionPanelProps {
  title: string
  icon?: React.ReactNode
  variant?: SectionVariant
  children: React.ReactNode
  className?: string
}

export function RequestSectionPanel({
  title,
  icon,
  variant = 'neutral',
  children,
  className = '',
}: RequestSectionPanelProps) {
  return (
    <div
      className={`rounded-lg border p-3 sm:p-4 ${variantClasses[variant]} ${className}`}
    >
      <h3 className="text-base font-semibold text-gray-900 mb-3 flex items-center gap-2">
        {icon && <span className="shrink-0 text-gray-600">{icon}</span>}
        {title}
      </h3>
      {children}
    </div>
  )
}
